export enum AppPages {
  Dashboard = "dashboard",
  ScheduledOfferings = "scheduled offerings",
  CoursesAndMaterials = "courses and materials",
  Locations = "locations",
  Terms = "terms",
  Educators = "educators",
  Roles = "roles",
  EducatorDashboard = "dashboard",
  Student = "students",
  StudentEnrolment = "student enrolments",
  Users = "users",
  Documents = "documents",
  StudentDashboard = "dashboard",
  MyEnrolment = "my enrolments",
  HandBook = "handbook",
  Reports = "reports",
  EducatorDocuments = "educator documents",
  CertificateSettings = "certificate settings",
  SLPDashboard = "dashboard",
}
